
import { Component, Vue, Prop } from 'nuxt-property-decorator'
import type { IFeedbackUser } from '~/components/sections/clients-feedback/types'
import type { Theme } from '~/types/theme'

@Component({
  components: {},
})

export default class ClientsFeedbackCard extends Vue {
  @Prop({ required: true, default: () => ({}), type: Object })
  readonly clientInfo!: IFeedbackUser

  @Prop({ default: 'light', type: String })
  readonly theme!: Theme

  get getImage () {
    return require(`~/assets/images/clientsFeedback/${this.clientInfo.image}.png`)
  }
}
